import { useEffect } from "react";

import { ActionButton, Error as DSError } from "@eisox/design-system";
import { captureException } from "@eisox/tools";
import { type ErrorComponentProps, Link } from "@tanstack/react-router";

import { m } from "~/paraglide/messages";

export const Error = ({ error }: ErrorComponentProps) => {
  // The router's error boundary swallows this error, so report it to Sentry ourselves.
  useEffect(() => captureException(error), [error]);

  return (
    <DSError.Root data-testid="error">
      <DSError.Title>500</DSError.Title>
      <DSError.Description>{m["500"]()}</DSError.Description>
      <ActionButton>
        <Link to={"/buildings"}>{m.my_buildings()}</Link>
      </ActionButton>
    </DSError.Root>
  );
};
